import { OriginRecordStatus } from "../../../enum/originRecordStatus"
import { TypeMaterialEnum } from "../../../enum/typeMaterialEnum"
import { UnitEnum } from "../../../enum/unitEnum"
import { Quantity } from "../../quantity"
import { DeclarationTypeEnum, declarationTypeToLabel } from "../../../enum/DeclarationTypeEnum"

export interface BSMaterialResultDashboard {
  id: string
  variantId: string
  variantName: string
  buildingId: string
  buildingName: string
  typeMaterial: TypeMaterialEnum
  itemType: string
  bsItemSousTypeEnum: string
  ficheId: string
  nomProduit: string
  quantity: number
  custom: boolean
  customMaterialId: string
  ficheUniteLabel: string
  re2020CarbonImpact: number
  re2020CarbonImpactPerSurface: number
  bsMaterialId: string
  resettable: boolean
  ficheUnite: UnitEnum
  code: string
  codeOccurrence: string
  baseQuantities: Quantity
  originRecordStatus: OriginRecordStatus
  enable: boolean
  lot: string
  sousLot: string
  overriddenMaterialId: string
  drv: number

  iniesClassificationLvl0: string
  iniesClassificationLvl1: string
  iniesClassificationLvl2: string
  iniesClassificationLvl3: string
  iniesClassificationLvl4: string

  lotLabel: string
  carbonStockPerSurface: number
  declarationType: DeclarationTypeEnum
  bsMacroComponentKey: string // This is the enum from backend, like: "CARRELAGE_LOGEMENT_BUREAU_ENSEIGNEMENT_OPTIMISE"
  sousLotLabel: string
  bsMacroComponentLabel: string
  bsItemLabel: string
}

export function toDeclarationTypeLabel(bsMaterialResultDashboard: BSMaterialResultDashboard): string {
  return declarationTypeToLabel(bsMaterialResultDashboard.declarationType)
}
